module.exports = __webpack_public_path__ + "static/media/diversion.849adb32.svg";